import WebLayout from './Web/EmailFieldLayout.web';
import MobileLayout from './Mobile/EmailFieldLayout.mobile';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
